import * as React from 'react';

import { IconNames } from '@packages/ui';
import { IconText } from './IconText';
import { LinkItemForFooter, LinkItemForFooterProps } from './LinkItemForFooter';

export interface FooterLinkListProps extends LinkItemForFooterProps {
  icon?: IconNames;
}

export const FooterLinkList: React.FC<FooterLinkListProps> = ({ icon, children, ...otherProps }) => (
  <LinkItemForFooter {...otherProps}>{icon ? <IconText icon={icon}>{children}</IconText> : children}</LinkItemForFooter>
);
